import { Routes, Route } from 'react-router-dom';
import NewRegistration from '../modules/nikshay/components/New-Registration';

const NikshayRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<NewRegistration />} />
      <Route path="/registration" element={<NewRegistration />} />
    </Routes>
  );
};

export default NikshayRoutes;